/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Image } from '@ta-interaktiv/contentbricks'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'

// TODO Set the correct article ID here
// const ARTICLE_ID = '00000000'

const isMobile = browserCheck.isMobile

export function AppComponent() {
  const params = new URL(window.location).searchParams
  const type = params.get('type')

  if (type === 'anhaenger') {
    return (
      <div className='index'>
        <ThemeSwitch />
        {isMobile ? (
          <Image
            file={require('../../images/anhaenger.svg')}
            className={isMobile ? 'mobileImage' : 'desktopImage'}
          ></Image>
        ) : (
          <Image
            file={require('../../images/anhaenger-desktop.svg')}
            className={isMobile ? 'mobileImage' : 'desktopImage'}
          ></Image>
        )}
      </div>
      // </div>
    )
  }

  if (type === 'direkteinstieg') {
    return (
      <div className='index'>
        <ThemeSwitch />
        {isMobile ? (
          <Image
            file={require('../../images/direkteinstieg.svg')}
            className={isMobile ? 'mobileImage' : 'desktopImage'}
          ></Image>
        ) : (
          <Image
            file={require('../../images/direkteinstieg-desktop.svg')}
            className={isMobile ? 'mobileImage' : 'desktopImage'}
          ></Image>
        )}
      </div>
      // </div>
    )
  }

  if (type === 'einparkhilfen') {
    return (
      <div className='index'>
        <ThemeSwitch />
        {isMobile ? (
          <Image
            file={require('../../images/einparkhilfen.svg')}
            className={isMobile ? 'mobileImage' : 'desktopImage'}
          ></Image>
        ) : (
          <Image
            file={require('../../images/einparkhilfen-desktop.svg')}
            className={isMobile ? 'mobileImage' : 'desktopImage'}
          ></Image>
        )}
      </div>
      // </div>
    )
  }

  if (type === 'fahrradstrasse') {
    return (
      <div className='index'>
        <ThemeSwitch />
        {isMobile ? (
          <Image
            file={require('../../images/fahrradstrasse.svg')}
            className={isMobile ? 'mobileImage' : 'desktopImage'}
          ></Image>
        ) : (
          <Image
            file={require('../../images/fahrradstrasse-desktop.svg')}
            className={isMobile ? 'mobileImage' : 'desktopImage'}
          ></Image>
        )}
      </div>
      // </div>
    )
  }

  if (type === 'kostenpflichtig') {
    return (
      <div className='index'>
        <ThemeSwitch />
        {isMobile ? (
          <Image
            file={require('../../images/kostenpflichtig.svg')}
            className={isMobile ? 'mobileImage' : 'desktopImage'}
          ></Image>
        ) : (
          <Image
            file={require('../../images/kostenpflichtig-desktop.svg')}
            className={isMobile ? 'mobileImage' : 'desktopImage'}
          ></Image>
        )}
      </div>
      // </div>
    )
  }

  if (type === 'lernfahrten') {
    return (
      <div className='index'>
        <ThemeSwitch />
        {isMobile ? (
          <Image
            file={require('../../images/lernfahrten.svg')}
            className={isMobile ? 'mobileImage' : 'desktopImage'}
          ></Image>
        ) : (
          <Image
            file={require('../../images/lernfahrten-desktop.svg')}
            className={isMobile ? 'mobileImage' : 'desktopImage'}
          ></Image>
        )}
      </div>
      // </div>
    )
  }

  if (type === 'rechtsabbiegen') {
    return (
      <div className='index'>
        <ThemeSwitch />
        {isMobile ? (
          <Image
            file={require('../../images/rechtsabbiegen.svg')}
            className={isMobile ? 'mobileImage' : 'desktopImage'}
          ></Image>
        ) : (
          <Image
            file={require('../../images/rechtsabbiegen-desktop.svg')}
            className={isMobile ? 'mobileImage' : 'desktopImage'}
          ></Image>
        )}
      </div>
      // </div>
    )
  }

  if (type === 'rechtsvorbeifahren') {
    return (
      <div className='index'>
        <ThemeSwitch />
        {isMobile ? (
          <Image
            file={require('../../images/rechtsvorbeifahren.svg')}
            className={isMobile ? 'mobileImage' : 'desktopImage'}
          ></Image>
        ) : (
          <Image
            file={require('../../images/rechtsvorbeifahren-desktop.svg')}
            className={isMobile ? 'mobileImage' : 'desktopImage'}
          ></Image>
        )}
      </div>
      // </div>
    )
  }

  if (type === 'reissverschluss') {
    return (
      <div className='index'>
        <ThemeSwitch />
        {isMobile ? (
          <Image
            file={require('../../images/reissverschluss.svg')}
            className={isMobile ? 'mobileImage' : 'desktopImage'}
          ></Image>
        ) : (
          <Image
            file={require('../../images/reissverschluss-desktop.svg')}
            className={isMobile ? 'mobileImage' : 'desktopImage'}
          ></Image>
        )}
      </div>
      // </div>
    )
  }

  if (type === 'rettungsgasse') {
    return (
      <div className='index'>
        <ThemeSwitch />
        {isMobile ? (
          <Image
            file={require('../../images/rettungsgasse.svg')}
            className={isMobile ? 'mobileImage' : 'desktopImage'}
          ></Image>
        ) : (
          <Image
            file={require('../../images/rettungsgasse-desktop.svg')}
            className={isMobile ? 'mobileImage' : 'desktopImage'}
          ></Image>
        )}
      </div>
      // </div>
    )
  }

  return null
}
